var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 利用可能な請求書はありません ")])}
var staticRenderFns = []

export { render, staticRenderFns }